module.exports = {"SubTexture":[{"width":73,"y":126,"height":73,"name":"light_bac","x":415},{"width":412,"y":1,"height":340,"name":"5logo_part1","x":1},{"width":110,"y":343,"height":54,"name":"btn_play_first_screen","x":1},{"width":110,"y":399,"height":54,"name":"btn_play_first_screen_hover","x":1},{"width":64,"y":1,"height":123,"name":"cube_shadow","x":415},{"width":58,"y":201,"height":69,"name":"cub","x":415}],"width":512,"height":512,"name":"introscreen","imagePath":"introscreen_tex.png"}


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/images/1x/introscreen_tex.json
// module id = 226
// module chunks = 0